exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-expansion-panels--accordion{width:100%;padding:0 4rem;margin:auto}.v-expansion-panel-header{color:inherit;position:relative;color:#2c3d4f;font-weight:700;min-height:auto!important}.v-expansion-panel-header:hover{background-color:#f6f6f6;transition:background-color .3s ease-in-out}.active,.v-expansion-panel--active>.v-expansion-panel-header{background:#f6f6f6}.v-expansion-panel-content__wrap{padding:16px 24px;border:1px solid #e6e6e6;border-top:none;font-weight:300}.faq-categories{padding:0 4rem;flex:0 1 30%}.faq-categories ul{background-color:#fff;border:1px solid #e6e6e6;margin:0;padding:0}.faq-categories ul li{position:relative;margin:0;border-bottom:1px solid #e6e6e6;list-style:none}.faq-categories ul li a{color:#000;padding:.75rem 1rem;display:block;text-decoration:none}.faq-categories ul li a:hover{background-color:#f1f1f1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fed76a5","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/faq/FrequentlyAskedQuestions.vue
// module id = 1769
// module chunks = 0